import { getAmpConfig } from 'shared/config/amp-config';

export const TEXAS_EDUCATION_AGENCY_MUNICIPALITY_ORG_SIS_ID =
  '1260921d-983a-4861-9d25-c497529467de';

export const NYC_DOE_ORG_SOURCE_ID = '54d263946cc968010000007a';
export const PUYALLUP_SD_ORG_SOURCE_ID = '5b0dbc5605f255000118c3d2';

export const getOnboardingUrl = () => getAmpConfig().onboarding;
